import ajax from "../utils/request";

const HotTagApi = {
  /********************************金刚区配置列表*********************************** */
  // 获取金刚区列表
  list(params) {
    return ajax({
      url: "/hottag/list",
      type: "post",
      params: params,
    });
  },
  save(param) {
    return ajax({
      url: "/hottag/add",
      type: "post",
      params: param,
    });
  },
  update(param) {
    return ajax({
      url: "/hottag/update",
      type: "post",
      params: param,
    });
  },
  remove(param) {
    return ajax({
      url: "/hottag/remove",
      type: "post",
      params: param,
    });
  },
};

export default HotTagApi;
